import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from '../messages';

export const pickList = {
  id: 'pick-list',

  getDocumentRequestNotificationProps: (docCount) => ({
    title: <FormattedMessage {...messages.printingPickListTitle} values={{ docCount }} />,
  }),
};
